import { render, staticRenderFns } from "./ResellerConnectedUser.vue?vue&type=template&id=80f3b382&scoped=true"
import script from "./ResellerConnectedUser.vue?vue&type=script&lang=js"
export * from "./ResellerConnectedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f3b382",
  null
  
)

export default component.exports